export default __webpack_public_path__ + "static/media/for-players-header.1f9d8317.png";